export { NgxCarouselModule } from './src/ngx-carousel.module';
export { NgxCarousel, NgxCarouselStore } from './src/ngx-carousel/ngx-carousel.interface';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/node_modules/ngx-carousel/index.js
// module id = ../../../../ngx-carousel/index.js
// module chunks = vendor